/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EnergyCharacteristics
 */
export interface EnergyCharacteristics {
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof EnergyCharacteristics
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof EnergyCharacteristics
   */
  readonly updated?: Date;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  energyCold: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  energyWarm: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  maximumInfiltrationTemperatureWarm: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  averageInfiltrationTemperatureCold: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  averageInfiltrationTemperatureWarm: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  powerCold: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  powerWarm: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  power: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  averageWarmWater: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  averageColdWater: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  maximumYearQuantityWarm: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  maximumYearQuantityCold: string | null;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  installation: string;
  /**
   *
   * @type {string}
   * @memberof EnergyCharacteristics
   */
  dataOwner: string;
}

/**
 * Check if a given object implements the EnergyCharacteristics interface.
 */
export function instanceOfEnergyCharacteristics(value: object): value is EnergyCharacteristics {
  if (
    (!("energyCold" in (value as Record<string, any>)) &&
      !("energy_cold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["energyCold"] === undefined &&
      (value as Record<string, any>)["energy_cold"] === undefined)
  )
    return false;
  if (
    (!("energyWarm" in (value as Record<string, any>)) &&
      !("energy_warm" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["energyWarm"] === undefined &&
      (value as Record<string, any>)["energy_warm"] === undefined)
  )
    return false;
  if (
    (!("maximumInfiltrationTemperatureWarm" in (value as Record<string, any>)) &&
      !("maximum_infiltration_temperature_warm" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumInfiltrationTemperatureWarm"] === undefined &&
      (value as Record<string, any>)["maximum_infiltration_temperature_warm"] === undefined)
  )
    return false;
  if (
    (!("averageInfiltrationTemperatureCold" in (value as Record<string, any>)) &&
      !("average_infiltration_temperature_cold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["averageInfiltrationTemperatureCold"] === undefined &&
      (value as Record<string, any>)["average_infiltration_temperature_cold"] === undefined)
  )
    return false;
  if (
    (!("averageInfiltrationTemperatureWarm" in (value as Record<string, any>)) &&
      !("average_infiltration_temperature_warm" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["averageInfiltrationTemperatureWarm"] === undefined &&
      (value as Record<string, any>)["average_infiltration_temperature_warm"] === undefined)
  )
    return false;
  if (
    (!("powerCold" in (value as Record<string, any>)) &&
      !("power_cold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["powerCold"] === undefined &&
      (value as Record<string, any>)["power_cold"] === undefined)
  )
    return false;
  if (
    (!("powerWarm" in (value as Record<string, any>)) &&
      !("power_warm" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["powerWarm"] === undefined &&
      (value as Record<string, any>)["power_warm"] === undefined)
  )
    return false;
  if (!("power" in value) || value["power"] === undefined) return false;
  if (
    (!("averageWarmWater" in (value as Record<string, any>)) &&
      !("average_warm_water" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["averageWarmWater"] === undefined &&
      (value as Record<string, any>)["average_warm_water"] === undefined)
  )
    return false;
  if (
    (!("averageColdWater" in (value as Record<string, any>)) &&
      !("average_cold_water" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["averageColdWater"] === undefined &&
      (value as Record<string, any>)["average_cold_water"] === undefined)
  )
    return false;
  if (
    (!("maximumYearQuantityWarm" in (value as Record<string, any>)) &&
      !("maximum_year_quantity_warm" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumYearQuantityWarm"] === undefined &&
      (value as Record<string, any>)["maximum_year_quantity_warm"] === undefined)
  )
    return false;
  if (
    (!("maximumYearQuantityCold" in (value as Record<string, any>)) &&
      !("maximum_year_quantity_cold" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumYearQuantityCold"] === undefined &&
      (value as Record<string, any>)["maximum_year_quantity_cold"] === undefined)
  )
    return false;
  if (!("installation" in value) || value["installation"] === undefined) return false;
  if (
    (!("dataOwner" in (value as Record<string, any>)) &&
      !("data_owner" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["dataOwner"] === undefined &&
      (value as Record<string, any>)["data_owner"] === undefined)
  )
    return false;
  return true;
}

export function EnergyCharacteristicsFromJSON(json: any): EnergyCharacteristics {
  return EnergyCharacteristicsFromJSONTyped(json, false);
}

export function EnergyCharacteristicsFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): EnergyCharacteristics {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    energyCold: json["energy_cold"],
    energyWarm: json["energy_warm"],
    maximumInfiltrationTemperatureWarm: json["maximum_infiltration_temperature_warm"],
    averageInfiltrationTemperatureCold: json["average_infiltration_temperature_cold"],
    averageInfiltrationTemperatureWarm: json["average_infiltration_temperature_warm"],
    powerCold: json["power_cold"],
    powerWarm: json["power_warm"],
    power: json["power"],
    averageWarmWater: json["average_warm_water"],
    averageColdWater: json["average_cold_water"],
    maximumYearQuantityWarm: json["maximum_year_quantity_warm"],
    maximumYearQuantityCold: json["maximum_year_quantity_cold"],
    installation: json["installation"],
    dataOwner: json["data_owner"],
  };
}

export function EnergyCharacteristicsToJSON(json: any): EnergyCharacteristics {
  return EnergyCharacteristicsToJSONTyped(json, false);
}

export function EnergyCharacteristicsToJSONTyped(
  value?: Omit<EnergyCharacteristics, "uuid" | "created" | "updated"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    energy_cold: value["energyCold"],
    energy_warm: value["energyWarm"],
    maximum_infiltration_temperature_warm: value["maximumInfiltrationTemperatureWarm"],
    average_infiltration_temperature_cold: value["averageInfiltrationTemperatureCold"],
    average_infiltration_temperature_warm: value["averageInfiltrationTemperatureWarm"],
    power_cold: value["powerCold"],
    power_warm: value["powerWarm"],
    power: value["power"],
    average_warm_water: value["averageWarmWater"],
    average_cold_water: value["averageColdWater"],
    maximum_year_quantity_warm: value["maximumYearQuantityWarm"],
    maximum_year_quantity_cold: value["maximumYearQuantityCold"],
    installation: value["installation"],
    data_owner: value["dataOwner"],
  };
}
